import {
  Box,
  Button,
  Container
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { Link, useSearchParams } from "react-router-dom";
import CustomTabPanel from "../components/TabPanel/CustomTabPanel";
import StyledTab from "../components/TabPanel/StyledTab";
import StyledTabs from "../components/TabPanel/StyledTabs";
import Object from "./Object";

export default function ObjectOverview({ userInfo }) {

  const intl = useIntl();

  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get('tab') ?? 'private';

  const handleChange = (event, newValue) => {
    setSearchParams({ tab: newValue });
  };

  const changeTab = (index) => {
    setSearchParams({ tab: index });
  }

  return (
    <Container>
      <Button
        variant="contained"
        color="success"
        component={Link}
        to="/object/new"
        sx={{ float: "right" }}
      >
        <FormattedMessage id="Overview.create" />
      </Button>
      <h3><FormattedMessage id="Object.heading" /></h3>
      <p style={{ color: 'gray' }} ><FormattedMessage id="Object.ofWhat" /></p>
      <Box xs={{ width: '100%' }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="style data tabs"
        >
          <StyledTab value='private' label={intl.formatMessage({ id: "Object.private" })} />
          <StyledTab value='public' label={intl.formatMessage({ id: "Object.public" })} />
          {userInfo?.isAdmin && <StyledTab value='additional' label={intl.formatMessage({ id: "Object.additional" })} />}
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={'private'} >
        <Object userInfo={userInfo} publicFlag={false} allFlag={false} changeTab={changeTab} tab={'private'} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={'public'} >
        <Object userInfo={userInfo} publicFlag={true} allFlag={false} changeTab={changeTab} tab={'public'} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={'additional'} >
        <Object userInfo={userInfo} publicFlag={false} allFlag={true} changeTab={changeTab} tab={'additional'} />
      </CustomTabPanel>
    </Container>
  );
}
